module.exports = __webpack_public_path__ + "img/MasterCard.42fc3210.svg";